import { GlobalStyles } from "@mui/material";

import { getFullScreenPopupStyles } from "../utils/quotesGridStyles";

export const QuotesFullScreenPopupStyles = ({
  active,
}: {
  active: boolean;
}): React.JSX.Element | null =>
  active ? <GlobalStyles styles={getFullScreenPopupStyles} /> : null;
